/*
 * @Author: xiang.gao 57524479+GaoXiang0403@users.noreply.github.com
 * @Date: 2023-01-30 08:46:50
 * @LastEditors: Json Weng dinglong.weng@travel-easy.com
 * @LastEditTime: 2024-07-16 19:30:05
 * @FilePath: /base-frontend/src/core/api/base.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ApiService from "@/core/services/ApiService";
import Config from "@/core/config/ApiConfig";

export default {
  getMenuConfig() {
    return ApiService.post(Config.baseApiUrl + "/api/config/menu", {});
  },

  getCountryData() {
    return ApiService.post(
      Config.baseApiUrl + "/api/data-source/global-data/country",
      {}
    );
  },

  getPhoneCodeData() {
    return ApiService.post(
      Config.baseApiUrl + "/api/data-source/global-data/country-phone-code",
      {}
    );
  },

  getTaggingData(params) {
    return ApiService.post(
      Config.baseApiUrl + "/api/data-source/tagging/tag",
      params
    );
  },

  getTaggingGroupData(params) {
    return ApiService.post(
      Config.baseApiUrl + "/api/data-source/tagging/group",
      params
    );
  },

  getBrandSourceData(params) {
    return ApiService.post(Config.pimApiUrl + "/api/data-source/brand", params);
  },

  getCategorySourceData(params) {
    return ApiService.post(
      Config.pimApiUrl + "/api/data-source/category",
      params
    );
  },

  getMerchantSourceData(params) {
    return ApiService.post(
      Config.merchantApiUrl + "/api/data-source/merchant",
      params
    );
  },

  getCustomerSourceData(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/basic/data-source/customers",
      params
    );
  },

  getUserSourceData(params) {
    return ApiService.post(Config.baseApiUrl + "/api/data-source/user", params);
  },

  getAccountSourceData(params) {
    return ApiService.post(
      Config.distributionApiUrl + "/api/data-source/account/name",
      params
    );
  },

  getInfluencerGroupSourceData(params) {
    return ApiService.post(
      Config.distributionApiUrl + "/api/data-source/account/influencer-group",
      params
    );
  },

  getWarehouseData(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/basic/data-source/warehouse",
      {
        active: 1,
        ...params,
      }
    );
  },

  getUserOperatingEntity(params?) {
    return ApiService.post(
      Config.baseApiUrl + "/api/authorize/me/operating-entity",
      params
    );
  },

  getSsoApps(params) {
    return ApiService.post(Config.baseApiUrl + "/api/sso/apps", params);
  },

  getSsoAppUrl(url, params) {
    return ApiService.post(url, params);
  },

  getSsoAppsOptions(params) {
    return ApiService.post(
      Config.baseApiUrl + "/api/data-source/app-data/options",
      params
    );
  },
};
